import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    var list = request({
        url: 'rootRole/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
export const fetchSelect = query => {  
    var list = request({
        url: 'rootRole/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'rootRole/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getTreeData = query => {  
    var list = request({
        url: 'rootRoleItem/getTreeData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getCheckData = query => {  
    var list = request({
        url: 'rootRoleItem/selectMapData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 
 

//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'rootRole/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const saveBind = query => {  
    var list = request({
        url: 'rootRoleItem/insertBatch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 

export const handDelete = query => {  
    var list = request({
        url: 'rootRole/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'rootRole/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};




